/** Hide live counts until this many accounts exist. Below that, the figures are noise. */
export const MIN_PUBLIC_ACCOUNTS = 20;

export function shouldShowPublicUsage(accountCount: number): boolean {
  return Number.isInteger(accountCount) && accountCount >= MIN_PUBLIC_ACCOUNTS;
}

/** Largest power of ten that does not exceed count. 23 → 10, 156 → 100, 2500 → 1000. */
function stepFor(count: number): number {
  let step = 1;
  while (step * 10 <= count) step *= 10;
  return step;
}

/**
 * Floor to one significant digit so the public figure never exceeds the real count.
 * Counts under 10 have no honest "+" bucket.
 */
export function roundedPublicCount(count: number): number | null {
  if (!Number.isInteger(count) || count < 10) return null;
  const step = stepFor(count);
  return Math.floor(count / step) * step;
}

function grouped(value: number): string {
  return String(value).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

/** "20+ accounts" or "under 10 documents stored". Noun is the already-plural label. */
export function formatPublicCount(count: number, noun: string): string {
  const rounded = roundedPublicCount(count);
  if (rounded === null) return `under 10 ${noun}`;
  return `${grouped(rounded)}+ ${noun}`;
}
